import { TOKEN_KEY, API_URL, PHONE_CODES } from "./../../constants";
import { useMemo, useState, useEffect } from "react";
import { IResourceComponentsProps, useTranslate, useCustom } from "@refinedev/core";
import { useParams } from "react-router-dom";
import { Edit, useForm } from "@refinedev/antd";

import {
    Form,
    Input,
    Avatar,
    Row,
    Col,
    Card,
    Typography,
    Space,
    Radio,
    InputProps,
    Select
} from "antd";

import MaskedInput from "antd-mask-input";

const { Text } = Typography;

import { IUser } from "interfaces";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();
    const { formProps, saveButtonProps, queryResult } = useForm<IUser>();
    // const [customerPhone, setCustomerPhone] = useState('');
    const [phoneMask, setPhoneMask] = useState('');
    // const [phoneCodes, setphoneCodes] = useState([] as any[]);
    const {id} = useParams();

    const phoneCodes = PHONE_CODES?.map(item => { return { label: `${item.name} (${item.code})`, value: item.iso, mask: item.mask}}) ?? [];

    const changePhoneCode = (value: any) => {
        console.log(`selected ${value}`);
        let findMask = phoneCodes?.find(item => item.value===value)?.mask;
        if(Array.isArray(findMask)){
            let mask =  findMask[findMask.length - 1]; // findMask.map((item: any) => { return { mask: item.replaceAll("9","0"), lazy: true } });
            console.log(mask);
            setPhoneMask(mask?.replaceAll("9","0"));
        } else {            
            let mask = findMask; //Array.isArray(findMask) && findMask?.length ? findMask[findMask.length - 1] : findMask; // pega último mask por padrão
            console.log(mask);
            setPhoneMask(mask?.replaceAll("9","0") || "(00) 00000-0000");
        }        
    };

    // Pega userRoles
    const urlCustomers = `${API_URL}/userRoles`;
    const { data } = useCustom<{data: any;}>({ url: urlCustomers, method: "get"});
    const result : any = data?.data;                
    console.log(result);
    const roles = result?.map(
        (item : any) => {
            return {
                value: item.value,
                label: item.label,
                disabled: ["owner"].includes(item.value) ? true : false
                }
        }
    );

    return (
        <Edit
            isLoading={queryResult?.isFetching}
            saveButtonProps={saveButtonProps}
        >
            <div className="premium-form">
            <Form
                {...formProps}
                layout="vertical"
                initialValues={{
                    active: true,
                    ...formProps.initialValues,
                }}
            >
                <Row gutter={[64, 0]} wrap>
                    <Col xs={24} lg={14}>
                        <Card bordered={false} style={{ borderRadius: 16, border: "1px solid var(--border-color)", boxShadow: "var(--shadow-md)" }} title={<span style={{ fontWeight: 700, fontSize: "1.05rem" }}>Dados do funcionário</span>}>
                        <Form.Item
                            label={t("users.fields.name")}
                            name="name"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input disabled={true}/>
                        </Form.Item>     
                        <Form.Item
                            label={t("users.fields.email")}
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    type: "email",
                                },
                            ]}
                        >
                            <Input disabled={true}/>
                        </Form.Item>
                        <Space.Compact style={{ width: '100%' }}>
                        <Form.Item
                            label={"País"}
                            name="countryCode"
                            style={{ width: '40%' }}
                        >
                            <Select
                                showSearch
                                disabled={true}
                                // defaultValue="BR"
                                options={phoneCodes}
                                onChange={changePhoneCode}
                                // onSearch={onSearch}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label={t("users.fields.phone")}
                            name="phone"
                            style={{ width: '60%' }}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <MaskedInput
                                    disabled={true}
                                    mask={phoneMask || "(00) 00000-0000"}
                                    >
                                    {/* 
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore */}
                                    {/* {(props: InputProps) => <Input {...props} />} */}
                            </MaskedInput>                             
                        </Form.Item>
                        </Space.Compact>
                        <Form.Item
                            label={t("users.filter.role.label")}
                            name="role"                       
                            tooltip={"Tipo de acesso ao sistema"}     
                        >
                            <Select
                                allowClear
                                placeholder={t("users.filter.role.placeholder")}
                                options={roles}
                                disabled={["owner"].includes(formProps?.initialValues?.role)}
                            />
                        </Form.Item>
                        <Form.Item
                            label={t("users.fields.active.title")}
                            name="active"
                        >
                            <Radio.Group>
                                <Radio value={true}>{t("users.fields.active.true")}</Radio>
                                <Radio value={false}>{t("users.fields.active.false")}</Radio>
                            </Radio.Group>
                        </Form.Item>                                        
                        </Card>
                    </Col>
                    <Col xs={24} lg={10}>
                        {/* <Form.Item
                            label={t("users.fields.address")}
                            name={["address", "text"]}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input.TextArea rows={8} />
                        </Form.Item> */}                        
                    </Col>
                    {/* <Col xs={24} lg={8}>
                        <Form.Item
                            label={t("users.fields.address")}
                            name={["address", "text"]}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input.TextArea rows={8} />
                        </Form.Item>
                    </Col> */}
                </Row>
            </Form>
            </div>
        </Edit>
    );
};
